import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import Image from '@stencil/image';
import {BaseColumnWrap} from '../../../../CommonStyleUtils/dwebCommon.styles';

export const AutocompleteWrapperStyles = styled(BaseColumnWrap)(
  props => `
  position: relative;
  margin-left:${props.theme.spacing.custom(7)};
`,
);

export const SearchInputStyles = styled.input(
  props => `
  display: inline-flex;
  width:90%;
  border: none;
  height:2.5rem;
  font-size: ${props.theme.font.large};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;

  ::placeholder {
    color: ${props.theme.colors.downriver.medium};
    opacity: 1; /* Firefox */
    font-size: ${props.theme.font.large};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    height:2rem;
  }

  &:focus {
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
`,
);

export const SearchListItem = styled.li(props => {
  return `
    display: flex;
    align-items: center;
    border-top: 1px solid ${props.theme.colors.downriver.light};
    padding: ${props.theme.spacing.large};
    font-size: ${props.theme.font.custom(16)};
    background: ${
      // @ts-ignore
      props.isActive ? props.theme.colors.downriver.light : props.theme.colors.goWhite.base
    };
    &:first-child{
      border-top:none;
    }
  `;
});

export const SearchMenuStyles = styled.ul(
  props => `
  z-index: ${props.theme.misc.zIndex.xxlarge};
  position: absolute;
  top: ${props.top || '4rem'};
  left: ${props.left || '-2rem'};
  /* left: ${-props.theme.spacing.xlarge}; */
  list-style-type: none;
  background: ${props.theme.colors.goWhite.base};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  transform: translateY(4px);
  min-width: 54rem; /** zepline has 746px, change to it if need*/
  max-height: ${props.maxHeight ? props.maxHeight : '90vh'};
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${props.theme.colors.downriver.medium};
    box-shadow: 0 0 1px ${props.theme.colors.downriver.light};
  }
`,
);

export const SearchHotelNumber = styled.p(
  props => `
  position: relative;
  color:${props.theme.colors.downriver.medium};
  font-size:${props.theme.font.custom(14)};
  font-weight:normal;
  margin-top:${props.theme.spacing.small};
  `,
);

export const SearchListItemLocationName = styled.span`
  flex: 3;
  /* font-weight: bold; */
`;

export const SearchListItemLocationType = styled.div`
  flex: 1;
  text-align: right;
  font-weight: bold;
  text-transform: capitalize;

  /* these are needed so that <Text /> span inside rating div takes full height of its parent ( the div )*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ErrorMessage = styled.div(
  props => `
  color: ${props.theme.colors.goRed.base};
  font-size: ${props.theme.font.custom(14)};
  padding: ${props.theme.spacing.xsmall};
  font-weight:normal;
  position: absolute;
  right: 0;
`,
);

export const StyledIcon = styled.div(
  props => `
  height: ${props.theme.spacing.custom(24)};
  fill:${props.theme.colors.downriver.medium};
  width: ${props.theme.spacing.custom(24)};
  margin: 0 ${props.theme.spacing.custom(13)} 0 0;
`,
);

export const SearchLabelStyles = styled.label(
  props => `
  color: ${props.theme.colors.goWhite.base};
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
`,
);

export const RatingStyles = styled.span(props => {
  return `
  color: ${props.theme.colors.goWhite.base};
  background: ${getRatingsColor(props.rating)};
  border-radius: 2px;
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.small};
  display: flex;
  width: fit-content;
`;
});

export const TripadvisorImageStyles = styled(Image)`
  max-width: 3rem;
  padding-right: 0.4rem;
`;
